import { Month } from 'libs/time';
import { parseAPIUserBusinessData } from 'services/business-data/BusinessDataServiceHelper';
import { execGet } from 'services/RequestUtils';
import { IUserProfile } from 'types';

import { IExtendedUserProfileWithBusinessData } from './types/IUserProfileApi';
import { sanitizeExtendedUserProfile } from './UserProfileServiceHelper';

export async function fetchUserProfile(
  userId: string,
  options?: { period?: Month }
): Promise<IUserProfile> {
  const searchParams = new URLSearchParams();
  searchParams.set('include', 'BusinessData');
  searchParams.set('expand', 'BasicProfile,ExtendedProfile');

  if (options?.period) {
    searchParams.append('period', options.period.toString());
  }

  const apiUser = await execGet<IExtendedUserProfileWithBusinessData>(
    `${
      process.env.REACT_APP_OFFICE_API
    }/users/${userId}?${searchParams.toString()}`,
    { cache: true }
  );
  return {
    ...sanitizeExtendedUserProfile(apiUser),
    businessData: parseAPIUserBusinessData(
      apiUser.businessData,
      apiUser.calculationDate,
      apiUser.qualification
    )
  } as IUserProfile;
}
